import styled from "styled-components";
// import Modal from "@/atoms/Modal";
import Modal from "@/atoms/account/Modal";
import Button from "@/atoms/Button";
import Divider from "@/atoms/account/Divider";
import Link from "next/link";
import { colors, media } from "@literati/public-ui-shared-react";

const StyledModal = styled(Modal)`
  .close-modal {
    display: none;
  }
`;

const StyledModalContent = styled.div`
  padding: 2rem 0;
  max-width: 560px;
  overflow: scroll;

  ${media.md} {
    background: ${colors.white};
  }
`;

const Content = styled.div`
  padding: 1.25rem 3rem;
`;

const Heading = styled.div<{ $hasOnClose: boolean }>`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 27px;
`;

const Description = styled.div`
  ${media.sm} {
    padding: 1.25rem 0 0;
    margin: 0 auto;
    max-width: 350px;
  }
`;

/**
 * Modal that prompts user to confirm whether they want to create a new subscription
 * with the same child's name as an existing subscription on their account.
 */
export interface DupSubWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDupSubModalConfirm: (values: any) => void;
  childName: string;
  subId: string;
  loading?: boolean;
  formValues?: any;
}

function DupSubWarningModal({
  isOpen,
  onClose,
  onDupSubModalConfirm,
  childName,
  subId,
  loading = false,
  formValues,
}: DupSubWarningModalProps) {
  return (
    <StyledModal isOpen={isOpen} requestClose={onClose}>
      <StyledModalContent>
        <Content>
          <Heading
            $hasOnClose={Boolean(onClose)}
          >{`Start another subscription for ${childName}?`}</Heading>
          <Description>
            {`It looks like you already have an active subscription for ${childName}.`}
          </Description>
          <Description>
            Please confirm you&apos;d like to create a second subscription for
            this reader before continuing or view your current subscription
            details on the{" "}
            <Link href={`/account/subscription/${subId}`}>account page.</Link>{" "}
          </Description>
          <Button
            level="primary"
            color={"teal"}
            label="Start New Subscription"
            className="mt-6 w-full"
            onClick={() => onDupSubModalConfirm(formValues)}
            type="button"
            loading={loading}
          />
          <Divider className={"my-8"} />
          <Button onClick={onClose} className="w-full" level={"secondary"}>
            Cancel
          </Button>
        </Content>
      </StyledModalContent>
    </StyledModal>
  );
}

export default DupSubWarningModal;
